<template lang="pug">
.external-tile-data
  div(v-for="t in entries", :key="Id(t)", v-if="t.show")
    v-tile-layer(:animationLod="Store.config.tileLayer.animationLod", :lodBias="Store.config.tileLayer.lodBias", :cacheSize="Store.config.tileLayer.cacheSize")
      TextureProvider(:params="t.colorParams", :baseUrl="t.baseUrl")
</template>


<script lang="ts">
import Vue from 'vue'
import TextureProvider from "./TextureProvider";
import { store } from '../../store';

export default Vue.extend({
  components: {
    TextureProvider,
  },
  props: {
    frame: { required: true },
  },
  computed: {
    entries() {
      return store.modules.externalTileData.entries
    }
  }
})
</script>